import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const { t } = useTranslation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && email.includes('@')) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    } else {
      setStatus('error');
    }
  };

  return (
    <section className="w-full bg-[#1A1A1A] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-2xl mx-auto text-center flex flex-col gap-8">
        {/* Heading */}
        <div className="flex flex-col gap-3">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white leading-[1.15]">
            {t('home.newsletter.heading')}
          </h2>
          <p className="text-sm text-white/40 font-light">
            {t('home.newsletter.body')}
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-3">
          <div className="relative flex-1 w-full">
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setStatus('idle');
              }}
              placeholder={t('home.newsletter.placeholder')}
              className="w-full px-6 py-3.5 bg-white/5 border border-white/10 rounded-full text-sm text-white placeholder:text-white/30 font-light focus:outline-none focus:border-[#7B1113]/50 transition-colors"
            />
          </div>
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3.5 bg-[#7B1113] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer text-center"
          >
            {t('home.newsletter.submit')}
          </button>
        </form>

        {/* Status messages */}
        {status === 'success' && (
          <p className="text-xs text-[#2D6A4F] font-light">
            {t('home.newsletter.success')}
          </p>
        )}
        {status === 'error' && (
          <p className="text-xs text-[#7B1113] font-light">
            {t('home.newsletter.error')}
          </p>
        )}

        {/* Privacy note */}
        <p className="text-[10px] text-white/20 font-light">
          {t('home.newsletter.privacy')}
        </p>
      </div>
    </section>
  );
}